// extracted by css-extract-rspack-plugin
export default {"ColorPill":"za0kK","Table":"n5BGv"};